import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.forest};
  padding: 20px;
  justify-content: center;
`
